import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import AdminRouter from '../admin';
import Content from '../system/content';
import Cabinet from '../cabinet';
import OperatorRouter from '../operator';
import Administration from '../administration';
import RegistryRouter from '../registry';
import {loadUser} from 'redux/actions/auth';
import Page404Full from 'components/page404-full';


const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(loadUser())
})

const mapStateToProps = state => ({
	user: state.auth.get('user')
})

class AppRouter extends Component {
	render() {
		const { user } = this.props
		return (
			<Switch>
				{this.props.user && <Route path="/admin" component={user.get('is_staff_admin') || user.get('is_staff_manager_document') || user.get('is_superuser') || user.get('is_admin_institution') ?  AdminRouter : AdminRouter} />}
				{this.props.user && <Route path="/operator" component={user.get('is_staff_operator') ? OperatorRouter : Page404Full} />}
				{this.props.user && <Route path="/cabinet" component={Cabinet} />}
				{this.props.user && <Route path="/registry" component={user.get('is_staff_admin') || user.get('is_superuser') || user.get('is_registry') ? RegistryRouter : Page404Full} />}
				{this.props.user && <Route path="/administration" component={user.get('is_superuser') || user.get('is_staff_manager_institution') ? Administration : Page404Full} />}
        <Route path="/" component={Content} />
			</Switch>
		)
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRouter));



// WEBPACK FOOTER //
// ./src/application/router.js